import React, {useEffect, useState} from "react";
import { Box, Paper } from "@mui/material";
import HeaderViewDocument from "../../components/layout/readDocument/Header";
import BodyViewDocument from "../../components/layout/readDocument/body";
import { useAuth } from '../../shared/context';

const page = {
    with: '100%',
    height: 'auto',
}

const ReadDocument = () => {
    const { checkTokenValidity } = useAuth();
    const [selectedTitle, setSelectedTitle] = useState(''); 



    useEffect(()=>{
        checkTokenValidity();
        // eslint-disable-next-line
    }, []);

    return(
        <>
            <Box component={Paper} sx={page} p={2}>
                <HeaderViewDocument />
                <BodyViewDocument selectedTitle = {selectedTitle}  setSelectedTitle={setSelectedTitle}/>
            </Box>
        </>
    );
}

export default ReadDocument;